export default {
    count_of_normal_floors : {
        title : 'Количество этажей (надземных)',
        mask  : '{всего этажей в секции: section[count_of_normal_floors]}'
    },
    planned_deadline : {
        title : 'Планируемый срок сдачи',
        mask  : '{срок сдачи: section[planned_deadline]}'
    },
    description : {
        title : 'Описание секции',
        mask  : '{Описание секции: section[description]}'
    }
}